<style scoped>
.el-col-5 {
  width: 30%;
}
.chooseBox {
  display: flex;
  /* justify-content: center; */
  /* margin-top: 30px; */
}
.upload-txt {
  line-height: 6px;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.txt-color {
  text-decoration: none;
}
.clear-person {
  color: #4fa1a4;
  float: right;
  margin-right: 20px;
  text-decoration: underline;
  cursor: pointer;
}
.search-area-div {
  width: 120px;
}
.form-box {
  display: flex;
  flex-wrap: wrap;
}
.form-box .form-list {
  display: flex;
  width: 48%;
  margin-bottom: 20px;
  padding: 0 2%;
  box-sizing: border-box;
}
.form-box .form-list label {
  width: 120px;
  flex-shrink: 0;
  text-align: right;
  line-height: 36px;
}
.form-box .form-list label span {
  color: red;
}
.form-box .form-list .form-input {
  flex: 1;
  width: 100%;
}
.form-box .form-list .form-input p {
  color: #4fa1a4;
  text-align: left;
  margin-bottom: 0 !important;
}
.W250 {
  width: 250px;
}
.upload-pic /deep/ .el-form-item__content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;

}
.step-box{
  margin-bottom: 20px;
}
.btn-box{
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
}
.ipt-sty{
  width: 63%;
}
.el-col-6{
  display: flex;
}
.search-area-div {
  flex-shrink: 0;
  width: 120px;
  text-align: right;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <div class="step-box">
        <el-steps :active="active"  align-center>
          <el-step title="计算留存"></el-step>
          <el-step title="计算考核"></el-step>
        </el-steps>
      </div>
      <el-row :gutter="24" >
        <el-col :span="6">
          <div class="search-area-div">姓名/手机号：</div>
          <el-input size="mini" v-model="page.keyword" clearable class="ipt-sty" placeholder="请输入姓名/手机号"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">药企名称：</div>
          <el-select size="mini" @change="handleChangeCompany" v-model="page.tenantGuid" filterable placeholder="请选择药企名称" class="ipt-sty">
            <el-option  v-for="item in companyList" :key="item.sendTenantGuid" :label="item.sendTenantName" :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">
            <el-tooltip class="item" effect="dark" content="平台考核后金额小于平台实际下发金额" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
            金额是否异常：
          </div>
          <el-select size="mini" v-model="page.isMoneyUnusual" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in moneyOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
         <el-button size="mini" type="text" @click="searchShow = !searchShow" :icon="searchShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ searchShow ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <div class="search-block mt15" v-if="searchShow">
        <el-col :span="6">
          <div class="search-area-div">账单月份：</div>
          <el-date-picker size="mini" class="ipt-sty" @change="getCycleData" value-format="yyyy-MM" v-model="page.accountMonth" type="month" placeholder="选择月">
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">部门名称：</div>
          <el-select size="mini" v-model="page.organisationName" filterable placeholder="请选择" class="ipt-sty" @change="getCycleData()" @focus="getOrganisationProgress(1)">
            <el-option    v-for="(item,index) in organisationSearchList" :key="index"  :label="item.organisationName" :value="item.organisationName">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">账单周期：</div>
          <el-select size="mini" v-model="page.billCycle" style="flex: 1" placeholder="请选择" @focus="getCycleFocus()" filterable>
            <el-option v-for="item in cycleData" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-col>
        </div>
      </el-row>
    </div>
    <div class="button-area btn-box">
      <div>
        <el-button size="mini" type="info" @click="calcAll">批量计算</el-button>
        <el-button size="mini" type="info" @click="bitchExport">批量导出</el-button>
        <el-button size="mini" type="info" @click="viewProgress">查看计算进度</el-button>
      </div>
      <div>
        <el-button size="mini" type="info" @click="openClearCurrentMonthDataDialog">清除本月数据</el-button>
        <el-button size="mini" type="info" icon="el-icon-setting" @click="setTableHead()">设置表头</el-button>
        <el-button size="mini" type="info" @click="$router.go(-1)">上一步</el-button>
      </div>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'"  v-loading.fullscreen.lock="fullscreenLoading">
      <el-table @selection-change="handleSelectionChange" :height='tableHeight' :data="tableData" stripe border style="width: 100%" >
        <el-table-column type="selection" :selectable='selectInit' width="60" header-align="center" align="center" v-if="tableData.length>0"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column  show-overflow-tooltip :width="(column.prop=='accountMonth'||column.prop=='staffName')?'100':'180'" header-align="center" :align="(column.prop=='accountMonth'||column.prop=='staffName'||column.prop == 'organisationName'||column.prop == 'isNeedChange'||column.prop =='cutDetailNote'||column.prop =='desc')?'left':'right'" v-for="(column,index) in bindTableColumns" :key="index"  :prop="column.prop"  :label="column.label" >
          <template slot-scope="scope">
            <!-- 核算月份 -->
            <span v-if="column.type == 0">{{scope.row[column.prop] | getMonth}}</span>
            <!-- 姓名 部门-->
            <span v-if="column.type == 1">{{scope.row[column.prop]}}</span>
            <!-- 定量扣奖金额（元） 照片质量（元） 上传资料质量（元）系统录入质量（元） 扣奖总额（元）扣奖明细说明 是否需要整改-->
            <span v-if="column.type == 2">{{calcReverse(scope.row[column.prop] | numDigit | numFmt)}}</span>
            <!-- 整改内容 -->
            <span v-if="column.type == 3">
              <a v-if="scope.row.isNeedChange=='是'" class="txt-color" @click="seeDetail(scope.row)">查看详情</a>
              <a v-else>-</a>
            </span>
            <!-- 任务计划金额（元） 金额类 -->
            <span v-if="column.type == 4">{{(scope.row[column.prop] ? Number(scope.row[column.prop]).toFixed(2) : '-') | numDigit | numFmt}}</span>
            <!-- 评分 -->
            <span v-if="column.type == 5">{{ Number(scope.row[column.prop]).toFixed(6)}}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="180px;">
          <template slot-scope="scope">
            <a v-if="scope.row.isNeedChange == '是'&&!scope.row.proofFile" class="txt-color" @click="toUploadFile(scope.row,'上传证明资料')">上传证明资料｜</a>
            <a v-if="scope.row.isNeedChange == '是'&&scope.row.proofFile" class="txt-color" @click="toUploadFile(scope.row,'查看证明资料')">查看证明资料｜</a>
            <a v-if="scope.row.blackNameListCount > configBlackParm&&!scope.row.isNotSend" class="txt-color" @click="changetSend(scope.row.guid)">是否禁止发放｜</a>
            <a class="txt-color" @click="toCheck(scope.row)">运营审核</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 上传/编辑资料-->
    <el-dialog :title="subTitle" :visible.sync="dialogVisible" width="45%">
      <template v-if="dialogVisible">
        <el-form label-width="140px" class="demo-ruleForm">
          <el-form-item class="upload-pic">
            <span slot="label" style="color: red">*</span>
            <span slot="label">上传打卡证明 </span>
            <el-upload class="fl" action="#" name="image" :limit="1" accept=".jpg,.png,.jpeg" list-type="picture-card" :headers="token" :file-list="fileList" :on-exceed="handleExceed" :on-remove="handleRemove" :http-request="uploadImage">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <div style="font-size: 12px;">说明:最大不超过5M的图片</div>
          </el-form-item>
          <el-form-item style="margin-bottom: 0px">
            <span slot="label" style="color: red">*</span>
            <span slot="label">打卡证明次数 </span>
            <el-input type="number" style="width: 60%; float: left" :maxlength="30" placeholder="请输入正整数" v-model="count">
            </el-input>
            <div style="font-size: 12px; float: left">说明:该上传打卡证明文件证明的打卡次数</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
          <el-button size="medium" type="info" @click="sureUpload">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 核算月 药企 // !批量计算弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisibleI" width="500px">
      <template v-if="dialogVisibleI">
        <el-form label-width="140px" class="demo-ruleForm">
          <el-form-item  required>
            <span slot="label">药企名称 </span>
            <el-select v-model="calForm.tenantGuid" placeholder="请选择药企名称" filterable class="ipt-sty fl" @change="tenantChange">
              <el-option v-for="item in companyList" :key="item.sendTenantGuid" :label="item.sendTenantName" :value="item.sendTenantGuid">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item required>
            <span slot="label">核算月份</span>
            <el-date-picker class="ipt-sty fl" @change="getCycleDataList" value-format="yyyy-MM" v-model="calForm.accountMonth" type="month" placeholder="选择月">
            </el-date-picker>
          </el-form-item>

          <el-form-item required>
            <span slot="label">组织名称</span>
            <el-select
              v-model="calForm.organisationGuid"
              filterable
              placeholder="请选择"
              class="ipt-sty fl"
              @change="organisationChange"
              @focus="getOrganisation()"
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item required>
            <span slot="label">任务类型 </span>
            <el-select v-model="calForm.buildType" placeholder="请选择药企名称" class="ipt-sty fl">
              <el-option v-for="item in taskOption" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item required>
            <span slot="label">计算方式 </span>
            <el-select v-model="calForm.isTrans" placeholder="请选择计算方式" class="ipt-sty fl">
              <el-option v-for="item in isTransOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item required>
            <span slot="label">扣奖类型 </span>
            <el-select v-model="calForm.deductType" placeholder="请选择扣奖类型" class="ipt-sty fl">
              <el-option v-for="item in deductTypeOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item v-if="calForm.buildType == '4'">
            <span slot="label">账单周期 </span>
            <el-select v-model="calForm.billCycle" filterable placeholder="请选择" class="ipt-sty fl" >
              <el-option v-for="item in billCycleData" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">人员姓名</span>
            <el-select
              v-model="personnel"
              filterable
              multiple
              clearable
              placeholder="请选择"
              class="ipt-sty fl"
              v-loading="staffLoading"
            >
              <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName" :value="item.guid">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item >
            <span slot="label">任务继承
              <el-tooltip class="item" effect="dark" content="将下级分配的任务转移给上级" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </span>
            <el-select v-model="calForm.isTaskMove" filterable placeholder="请选择" class="ipt-sty w80f fl" >
              <el-option
                v-for="item in isTaskMoveOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" plain @click="dialogVisibleI = false">取 消</el-button>
          <el-button size="medium" type="info" @click="bitchProduce">计 算</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- // !批量计算弹框 end -->
    <!-- 设置表头 -->
    <el-dialog title="表头设置" :visible.sync="dialogVisibleII" width="500px">
      <el-table
        :data="tableHeader"
        style="width: 100%"
        height="64vh"
        @selection-change="handleSelectionChangeColumn"
        >
        <el-table-column type="selection" width="60" header-align="left" align="left"></el-table-column>
        <el-table-column
          prop="label"
          label="列名"
          >
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisibleII = false">取 消</el-button>
        <el-button size="medium" type="info" @click="setTableHeadSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20,50,100,200]" :current-page="page.pageIndex" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <!-- // !查看计算进度start -->
    <ViewProgressBoxVue :showProgressBox.sync="showProgressBox" :companyList="companyList"></ViewProgressBoxVue>
    <!-- // !查看计算进度 end -->
     <!--  !清除当前月数据弹框 start -->
    <ClearCurrentMonthDataDialog
      ref="clearCurrentMonthDataDialogRef"
      :companyList="companyList"
      @success="getData(true)"
    ></ClearCurrentMonthDataDialog>
    <!--  !清除当前月数据弹框 end -->
  </div>
</template>
<script>
  import { route } from '@/api/apiRoute';
  import store from '@/store';
  import printDialogCheck from '@/components/printDialogCheck.vue';
  import ViewProgressBoxVue from './viewProgressBox.vue';
  import ClearCurrentMonthDataDialog from './components/clearCurrentMonthDataDialog.vue';
  import getTenantDetail from '../mixins/getTenantDetail';
  import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
  export default {
    components: {
      printDialogCheck,
      ViewProgressBoxVue,
      ClearCurrentMonthDataDialog,
    },
    mixins:[getTenantDetail],
    data() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      return {
        ServiceProviderTypeEnum,
        userInfo,
        organisationList: [],// 组织列表
        showProgressBox:false,
        searchShow:false,
        organisationGuidList:[],
        organisationNameList:[],
        organisationSearchList:[],
        dialogVisible: false,
        url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
        urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
        token: {
          'Content-Type': 'multipart/form-data',
          Authorization: store.state.token,
        },
        height: window.innerHeight - 260,
        configBlackParm: '',
        input: '',
        title: '添加账单',
        dialogFormVisible: false,
        fullscreenLoading: false,
        tableLoading: false,
        tableWrapLoading: false,
        value2: '',
        companyList: [], //公司选择\
        staffList: [], //人员列表
        idCode: '', //身份证号
        mobileNo: '', //手机号
        page: {
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
          tenantGuid: '',
          keyword: '',
          organisationName: '',
          accountMonth: '',
          isMoneyUnusual:'',
          isService: 'Y',
          billCycle:'全部'
        },
        guid: '',
        count: '', //打卡次数
        fileList: [], //文件
        tableData: [],
        multipleSelection: [],
        staffLoading: false,
        billCycle: null, //周期
        billCycleData:[],//周期数弹框
        billCycleOption: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
        cycleDate: null, //周期范围起止
        pickerOptions: {
          disabledDate: (time) => {
            return (
              time.getTime() < this.getMonthStartOrEnd(1, this.ruleForm.accountMonth) ||
              time.getTime() > this.getMonthStartOrEnd(2, this.ruleForm.accountMonth)
            );
          },
        },
        dialogVisibleI: false,
        calForm: {
          tenantGuid: '',
          accountMonth: '',
          buildType:'',
          isTaskMove:'',//任务转移
          billCycle:null
        },
        staffGuidList: [],
        personnel:[], // 人员信息
        accountMonthList: [],
        tenantGuidList: [],
        subTitle: '',
        active: 1,
        taskOption: [
          // { name: '所有任务', value: '1' },
          { name: '合格任务', value: '2' },
          { name: '合格和部分合格任务', value: '3' },
          { name: '本月消耗的任务额', value: '4' },
        ],
        isTaskMoveOption:[
          {label:'任务转移',value:'1'},
          {label:'任务不转移',value:'0'},
        ],
        moneyOption:[
          {label:'是',value:'是'},
          {label:'否',value:'否'},
        ],
        isTransOption:[
          {label:'正向',value:'1'},
          {label:'逆向',value:'0'},
        ],
        deductTypeOption:[
          {label:'金额',value:2},
          {label:'比例',value:1},
        ],
        dialogTitle:'请选择需要核算的月份和药企名称',
        dialogVisibleII:false,
        tableHeader:[
          {label:'核算月份',prop:'accountMonth',show:true, type:0},
          {label:'账单周期',prop:'billCycle',show:true,type:1},
          {label:'姓名',prop:'staffName',show:true,type:1},
          {label:'所属组织',prop:'organisationName',show:true,type:1},
          {label:'平台考核后金额（元）',prop:'finishMoney',show:true,type:4},
          {label:'平台实际下发金额（元）',prop:'realMoney',show:true,type:4},
          // {label:'任务计划金额（元）',prop:'planTaskSalary',show:false,type:4},
          {label:'任务完成金额（元）',prop:'taskSalary',show:true,type:4},
          {label:'时间管理评分（15%）',prop:'timeManageScore',show:true,type:5},
          {label:'质量管理评分（15%）',prop:'qualityManageScore',show:true,type:5},
          {label:'客户管理评分（45%）',prop:'customerManageScore',show:true,type:5},
          {label:'计划管理评分（15%）',prop:'planManageScore',show:true,type:5},
          {label:'使用频度评分（10%）',prop:'useCountScore',show:true,type:5},
          {label:'管控总评分',prop:'totalManageScore',show:true,type:5},
          {label:'照片质量（元）',prop:'cutPhotoMoney',show:false,type:2},
          {label:'上传资料质量（元）',prop:'cutUploadMoney',show:false,type:2},
          {label:'是否需要整改',prop:'isNeedChange',show:false,type:1},
          {label:'整改内容',prop:'desc',show:false,type:3},
          {label:'扣奖总额（元）',prop:'cutTotalMoney',show:true,type:2},
          {label:'扣奖明细说明',prop:'cutDetailNote',show:false,type:1}
        ],
        selectHeader:[],
        cycleData:[],
        tableHeight: window.innerHeight - 340,
        contentMainHeight: window.innerHeight - 280
      };
    },
    watch:{
      searchShow(val, oldVal) {
        if(val) {
          // 509 
          // 470
          this.tableHeight = window.innerHeight - 380;
          this.contentMainHeight=window.innerHeight - 359;
          return;
        }
        if(!val) {
          this.tableHeight = window.innerHeight - 340;
          this.contentMainHeight = window.innerHeight - 280;
          return;
        }
      }
    },
    async created() {
      await this.Mixins_getServiceProviderType();
      // 列表
      this.getCompany();
      this.getConfig();
    },
    destroyed() {
      sessionStorage.removeItem('staffDataDetail');
    },
    computed: {
      bindTableColumns() {
        return this.tableHeader.filter((column) => column.show);
      }
    },
    methods: {
      openClearCurrentMonthDataDialog() {
        this.$refs.clearCurrentMonthDataDialogRef.open();
      },
      getOrganisationProgress() {
        if (!this.page.tenantGuid ) {
          this.$message.error('请选择药企名称!');
          return;
        }
      },
      handleChangeTenant(val){
        if(val){
          this.getOrganisationList(val);
        }
      },
      handleChangeCompany(v) {
        let self = this;
        if (v) {
          self.page.organisationName = null;
          self.getCycleData();
        }else{
          self.cycleData = [];
          self.page.billCycle = null;
        }
        let query = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid:v,
          sendTenantGuid:localStorage.guid,
        };
        self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationSearchList = res.data.data.records || [];
          }
        });
      },
      selectInit(row, index) {
        return !(row.isNotSend == '是')
      },
      calcReverse(NUM) {
        let result = NUM == 0 ? 0 : NUM > 0 ? '-' + Number(NUM).toFixed(2) : Number(Math.abs(NUM)).toFixed(2);
        return Number(result)
      },
      calcAll() {
        if (!this.isAllEqual(this.tenantGuidList)) {
          this.$message.error('请选择同一个药企的数据批量计算！')
          return;
        }
        if (!this.isAllEqual(this.accountMonthList)) {
          this.$message.error('请选择同一个核算月的数据批量计算！')
          return;
        }
        if (this.staffGuidList.length == 0) {
          
        } else {
          this.dialogTitle = '请选择需要核算的任务类型';
          // this.bitchStaffProduce();
        }

        if(this.staffGuidList.length > 0){
          this.bitchStaffProduce()
          return
        }
        this.getCycleDataList(1);
        this.dialogVisibleI = true;
        this.personnel = []
      },
      handleSelectionChange(list) {
        var staffGuidList = [];
        var accountMonthList = [];
        var tenantGuidList = [];
        var organisationGuidList = [];
        var organisationNameList = [];
        list.forEach(item => {
          staffGuidList.push(item.staffGuid);
          accountMonthList.push(item.accountMonth);
          tenantGuidList.push(item.tenantGuid);
          organisationGuidList.push(item.organisationGuid)
          organisationNameList.push(item.organisationName)
        })
        this.staffGuidList = staffGuidList;
        this.accountMonthList = accountMonthList;
        this.tenantGuidList = tenantGuidList;
        this.organisationGuidList = organisationGuidList;
        this.organisationNameList = organisationNameList;
      },
      seeDetail(detail) {
        this.$router.push({
          path: '/waitCheckDetail',
          query: {
            productGuid: this.$route.query.productGuid,
            accountMonth: detail.accountMonth,
            tenantGuid: detail.tenantGuid,
            staffGuid: detail.staffGuid
          }
        })
      },
      //设置表头
      setTableHead(){
        this.dialogVisibleII = true;
      },
      //设置表头-选择
      handleSelectionChangeColumn(val){
        this.selectHeader = [];
        val.forEach(i=>{
          this.selectHeader.push(i.prop)
        })
      },
      //设置表头-提交
      setTableHeadSubmit(){
        if(this.selectHeader.length == 0){
          this.$message.error('请选择列名！');
          return
        }
        this.tableHeader.forEach(i=>{
          if(this.selectHeader.indexOf(i.prop)>-1){
            i.show = true;
          }else{
            i.show = false;
          }
        })
        this.dialogVisibleII = false;
      },
      //审核
      toCheck(detail) {
        this.$router.push({
          path: '/taskAudit',
          query: {
            productGuid: this.$route.query.productGuid,
            accountMonth: detail.accountMonth,
            tenantGuid: detail.tenantGuid,
            organisationGuid: detail.organisationGuid,
            staffName: detail.staffName

          }
        })
      },
      getConfig() {
        let that = this;
        that.api
          .get(
            `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=JZFFTCDHMDCS`,
          )
          .then((resp) => {
            console.log(resp.data);
            if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.configBlackParm = resp.data.data[0].parameterValue;
            }
          });
      },
      getMonthStartOrEnd(type, monthDate) {
        let time = null;
        if (type == 1) {
          time = this.$moment(monthDate).startOf('month').valueOf();
        } else {
          time = this.$moment(monthDate).endOf('month').valueOf();
        }
        return time;
      },
      empty() {
        let self = this;
        self.page.pageIndex = 1;
        self.page.pageSize = 50;
        self.page.keyword = '';
        self.page.organisationName = '';
        self.page.accountMonth = '';
        self.page.tenantGuid = '';
        self.page.isMoneyUnusual = '';
        self.page.isService = 'Y';
        self.page.billCycle = '';
        self.organisationSearchList = [];
        self.getData(true);
      },
      getData(flg) {
        let self = this;
        if (flg) {
          self.page.pageIndex = 1;
        }
        let query = JSON.parse(JSON.stringify(self.page));
        if (query.accountMonth) {
          query.accountMonth = query.accountMonth.replace('-', '');
        }
        query.billCycle =  query.billCycle == '全部' ? null : query.billCycle;
        this.fullscreenLoading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-list`, query)
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (res.data.data.records) {
                self.tableData = res.data.data.records;
                self.page.totalPage = res.data.data.totalPages;
                self.page.totalRows = res.data.data.totalRows;
              } else {
                self.tableData = []
                self.page.totalPage = 0;
                self.page.totalRows = 0;
              }

            } else {
              self.$message.error(res.data.msg);
            }
          })
          .catch(() => {
            self.tableWrapLoading = false;
          });
      },
      // 选择企业change
      tenantChange(val) {
        if (val) {
          let item = this.companyList.find(item=>item.sendTenantGuid === val)
          if (item) {
            this.calForm.tenantName = item.sendTenantName
          }
          this.personnel = [];
          this.getOrganisationList(val);
        }
      },
      //获取组织
      getOrganisationList(v) {
        let self = this;
        let query = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid:v,
          sendTenantGuid:localStorage.guid,
        }
        self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data.records || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      getStaff() {
        let self = this;
        if (!this.calForm.tenantGuid || !this.calForm.organisationGuid) {
          this.$message.error('请先选择药企和组织！');
          return;
        }
        let query = {
          pageIndex: 1,
          pageSize: -1,
          bizState: 'Y',
          containChildOrganisationGuid: this.calForm.organisationGuid,
          tenantGuid: this.calForm.tenantGuid,
        };
        this.staffLoading = true;
        // return new Promise((resolve, reject) => {
        self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffList = res.data.data.records;
            self.staffLoading = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      //获取周期
      getCycleData(type) {
        let self = this;
        if (!this.page.tenantGuid ) {
          // this.$message.error('请选择药企名称!');
          return;
        }
        if (!this.page.accountMonth ) {
          // this.$message.error('请选择核算月!');
          return;
        }
        let accountMonth = JSON.parse(JSON.stringify(this.page.accountMonth)) ;
        accountMonth = accountMonth.replace('-','') ; 
        let tenantGuid =  this.page.tenantGuid;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-bill-cycle?accountMonth=${accountMonth}&tenantGuid=${tenantGuid}`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.cycleData = res.data.data || [];
            if(self.cycleData && self.cycleData.length > 0){
              self.cycleData.forEach((i,index)=>{
                if(!i){
                  self.cycleData[index] = '全部';
                }
              })
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      //获取周期计算
      getCycleDataList(type) {
        let self = this;
        if (!this.calForm.tenantGuid && type !== 1) {
          // this.$message.error('请选择药企名称!');
          return;
        }
        if (!this.calForm.accountMonth && type !== 1) {
          // this.$message.error('请选择核算月!');
          return;
        }
        let accountMonth = type !== 1 ? JSON.parse(JSON.stringify(this.calForm.accountMonth)) : this.accountMonthList[0];
        accountMonth = type !== 1 ? accountMonth.replace('-','') : accountMonth; 
        let tenantGuid = type !== 1 ? this.calForm.tenantGuid : this.tenantGuidList[0];
        self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-bill-cycle?accountMonth=${accountMonth}&tenantGuid=${tenantGuid}`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.billCycleData = res.data.data || [];
            if(self.billCycleData && self.billCycleData.length > 0){
              self.billCycleData.forEach((i,index)=>{
                if(!i){
                  self.billCycleData[index] = '全部';
                }
              })
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      //获取人员列表
      getStaffChange(val) {
        let self = this;
        self.companyList.forEach((i) => {
          if (self.ruleForm.tenantGuid == i.sendTenantGuid) {
            self.ruleForm.tenantName = i.sendTenantName;
          }
        });
        self.ruleForm.staffGuid = val == 1 ? self.ruleForm.staffGuid : '';
        let query = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: self.ruleForm.tenantGuid,
        };
        self.staffLoading = true;
        return new Promise((resolve, reject) => {
          self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.staffList = res.data.data.records;
              self.staffLoading = false;
              resolve();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
      },
      //获取人员详情
      getStaffDetail(guid) {
        let self = this;
        if (self.staffList != null && self.staffList.length > 0) {
          self.staffList.forEach((i) => {
            if (guid == i.guid) {
              self.ruleForm.staffName = i.staffName;
              self.ruleForm.mobileNo = i.mobileNo;
              self.ruleForm.idCode = i.idCode;
            }
          });
        }
      },
      getCycleFocus(){
        if (!this.page.tenantGuid) {
          this.$message.error('请选择药企名称!');
          return;
        }
        if (!this.page.accountMonth) {
          this.$message.error('请选择账单月份!');
          return;
        }
      },
      //获取公司
      getCompany() {
        let self = this;
        let relType = null;
        try {
          // 可以直接访问到 mixins 中的 data 变量
          const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
          if (serviceProviderType == this.ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR) {
            relType = '123'; // 写死
          }
        } catch (error) { 
          console.log('error',error);
        }
        let query = {
          isService: true,
          tenantGuid: localStorage.guid,
          relType,
        };
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.companyList = res.data.data;
              if (sessionStorage.staffDataDetail) {
                let staffDataDetail = JSON.parse(sessionStorage.staffDataDetail);
                self.page.staffName = staffDataDetail.staffName;
                self.page.tenantGuid = staffDataDetail.tenantGuid;
                self.page.organisationName = staffDataDetail.organisationNames.toString();
                self.page.accountMonth = staffDataDetail.accountMonth.substr(0, 4) + '-' + staffDataDetail.accountMonth.substr(4, 5);
              }
              this.getData(false);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      //是否发放
      changetSend(guid) {
        var self = this;
        self
          .$confirm('是否设为禁止发放？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning',
          })
          .then(() => {
            let req = {
              guid,
              isNotSend: '是',
            };
            self.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/update`, req).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success('操作成功');
                self.getData();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {
            let req = {
              guid,
              isNotSend: '否',
            };
            self.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/update`, req).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success('操作成功');
                self.getData();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          });
      },

      //批量生成
      bitchProduce() {
        if (!this.calForm.tenantGuid) {
          this.$message.error('请选择药企')
          return
        }

        if (!this.calForm.accountMonth) {
          this.$message.error('请选择核算月份')
          return
        }

        if (!this.calForm.organisationGuid) {
          this.$message.error('请选择组织名称');
          return;
        }
        
        if (!this.calForm.buildType) {
          this.$message.error('请选择任务类型')
          return
        }
        if (!this.calForm.tenantGuid) {
          this.$message.error('请选择药企')
          return
        }
        if (!this.calForm.isTrans) {
          this.$message.error('请选择计算方式')
          return
        }
        // if (!this.calForm.deductType) {
        //   this.$message.error('扣奖类型')
        //   return
        // }
        // if (!this.calForm.isTaskMove) {
        //   this.$message.error('请选择任务继承')
        //   return
        // }
        // if(this.staffGuidList.length > 0){
        //   this.bitchStaffProduce()
        //   return
        // }
        let self = this;
        let req = {
          tenantGuid: this.calForm.tenantGuid,
          tenantName: this.calForm.tenantName,
          progressGuid: this.generateUUID(),
          accountMonth: this.calForm.accountMonth.replace('-', ''),
          serviceTenantGuid: localStorage.guid,
          organisationGuid:this.calForm.organisationGuid,
          organisationName:this.calForm.organisationName,
          createUserName:this.userInfo.staffName,
          createUserId:this.userInfo.userGuid,
          staffGuidList: this.personnel.length ? this.personnel : this.staffList.map(item=>item.guid), // 不选择人员的情况下 取部门的所有人员
          buildType:Number(this.calForm.buildType),
          // isTaskMove:this.calForm.isTaskMove,//任务转移
          deductType:1,
          isTrans:Number(this.calForm.isTrans),
          billCycle:(this.calForm.billCycle == '全部' || this.calForm.buildType !== '4')? null : this.calForm.billCycle,
        };
        self.calForm = {
          accountMonth: '',
          tenantGuid: '',
          buildType:'',
          isTaskMove:'',
          deductType:1,
          isTrans:'',
          billCycle:''
        }
        setTimeout(()=>{
          self.$message.warning('正在计算中，请稍后查看！');
        },100)
        self.dialogVisibleI = false;
        // self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/add-kafka`, req).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('计算成功！');
            this.personnel = []
            self.getData();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      isAllEqual(array) {
        if (array.length > 0) {
          return !array.some(function (value, index) {
            return value !== array[0];
          });
        } else {
          return true;
        }
      },
      bitchStaffProduce() {
        if (!this.isAllEqual(this.tenantGuidList)) {
          this.$message.error('请选择同一个药企的数据批量计算！')
          return;
        }
        if (!this.isAllEqual(this.accountMonthList)) {
          this.$message.error('请选择同一个核算月的数据批量计算！')
          return;
        }
        if (!this.isAllEqual(this.organisationGuidList)) {
          this.$message.error('请选择同一个部门数据批量计算！')
          return;
        }
        console.log(this.tenantGuidList)
        console.log(this.accountMonthList)

        let sendTenantItem = this.companyList.find(item=>item.sendTenantGuid === this.tenantGuidList[0])
        let self = this;
        let req = {
          tenantGuid: this.tenantGuidList[0],
          tenantName: sendTenantItem.sendTenantName,
          progressGuid: this.generateUUID(),
          accountMonth: this.accountMonthList[0],
          serviceTenantGuid: localStorage.guid,
          organisationGuid:this.organisationGuidList[0],
          organisationName:this.organisationNameList[0],
          createUserName:this.userInfo.staffName,
          createUserId:this.userInfo.userGuid,
          staffGuidList: this.staffGuidList,
          buildType:Number(this.calForm.buildType),
          isTaskMove:this.calForm.isTaskMove,
          deductType:1,
          isTrans:Number(this.calForm.isTrans),
          billCycle:(this.calForm.billCycle == '全部' || this.calForm.buildType !== '4')? null : this.calForm.billCycle
        };
        setTimeout(()=>{
          self.$message.warning('正在计算中，请稍后查看！');
        },100)
        self.dialogVisibleI = false;
        // self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/add`, req).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.calForm = {
              accountMonth: '',
              tenantGuid: '',
              buildType:'',
              isTaskMove:''
            }
            self.getData();
          } else {
            self.$message.error(res.data.msg);
          }
        });

      },
      generateUUID() {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === 'function') {
          d += performance.now(); //use high-precision timer if available
        }
        var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
        return uuid;
      },
      //批量导出
      bitchExport() {
        let self = this;
        let req = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: this.page.tenantGuid,
          organisationName: this.page.organisationName,
          staffName: this.page.staffName,
          accountMonth: this.page.accountMonth.replace('-', ''),
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/export`, req).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      // !查看计算进度
      viewProgress() {
        this.showProgressBox = true
      },
      reportJx(colNames, datas, sheetName, fileNam) {
        let self = this;
        self.api
          .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
            colNames: colNames,
            datas: datas,
            sheetName: sheetName,
            fileNam: fileNam,
          })
          .then((res) => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let fileName = fileNam;
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
          });
      },
      handleSizeChange(val) {
        let self = this;
        self.page.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) {
        let self = this;
        self.page.pageIndex = val;
        this.getData();
      },

      //上传资料
      toUploadFile(detail, title) {
        this.subTitle = title;
        this.fileList = detail.proofFile ? JSON.parse(detail.proofFile) : [];
        this.guid = detail.guid;
        this.count = detail.clockProofCount;
        this.dialogVisible = true;
      },
      sureUpload() {
        var self = this;
        if (this.fileList.length == 0) {
          this.$message.error(`请上传图片`);
          return;
        }
        if (!this.count) {
          this.$message.error(`请上传打卡证明次数`);
          return;
        }
        let req = {
          guid: this.guid,
          clockProofCount: this.count,
          proofFile: JSON.stringify(this.fileList),
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/staff-salary-task/data/update`, req).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('操作成功');
            self.getData();
          } else {
            self.$message.error(res.data.msg);
          }
        });

        this.dialogVisible = false;
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件`);
      },
      handleRemove(file) {
        let self = this;
        self.fileList = [];
      },
      uploadImage(file) {
        let self = this;
        console.log(file.file);
        let formData = new FormData();
        formData.append('image', file.file);
        self.api
          .postImage(self.urlImg, formData)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let item = {
                name: '要求示例图',
                url: res.data.data,
              };
              self.fileList.push(item);
              self.$message.success('上传成功');
            } else {
              elf.$message.error('上传失败,请重新上传!');
            }
          })
          .catch(() => {
            self.$message('上传失败,请重新上传');
          });
      },
      organisationChange(val) {
        if (val) {
          this.staffGuidList = [];
          this.organisationList.forEach((i) => {
            if (i.guid == val) {
              this.calForm.organisationName = i.organisationName;
            }
          });
          this.getStaff();
        }
      },
      getOrganisation(type) {
        if (!this.calForm.tenantGuid && type !== 1) {
          this.$message.error('请选择药企名称后再选择部门!');
          return;
        }
      },
    },
  };
</script>
